import type { GetStaticProps } from 'next'

import { NewtClient } from '@/utils/NewtClient'

export { BlogPage as default } from '@/components/pages/News/Blog'

export const getStaticProps: GetStaticProps = async () => {
  const client = new NewtClient()
  const [blogList, tagList] = await Promise.all([
    client.fetchBlogList(),
    client.fetchBlogTag(),
  ])

  const displayTagList = tagList.filter((tag) =>
    blogList.some((blog) => blog.tag.some(({ _id }) => _id === tag._id))
  )

  return {
    props: {
      blogList,
      tagList: displayTagList,
    },
  }
}
